import Cookies from "js-cookie";
import moment from "moment";

let a = ["", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]
let b = ["", "", 20, 30, 40, 50, 60, 70, 80, 90]
export function insWords(num,full) {
  if (!num) {
    return
  }
  if(typeof num !== "string"){
    num = num.toString()
  }

  let val = num.replace(/,/g, "")

  num = parseInt(val)
  if ((num = num.toString()).length > 9) return "overflow"
  let n = ("000000000" + num)
    .substr(-9)
    .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/)
  if (!n) return
  var str = ""
  str +=
    n[1] != 0
      ? (a[Number(n[1])] || Number(b[n[1][0]] + a[n[1][1]])) + `${full ?" Crore":" Cr. "}`
      : ""
  str +=
    n[2] != 0 ? " " + (a[Number(n[2])] || b[n[2][0]] + a[n[2][1]]) + " Lacs " : ""
  str +=
    n[3] != 0
      ? " " +  (a[Number(n[3])] || b[n[3][0]] + a[n[3][1]]) + " Thousand "
      : ""
  str += (n[4] != 0) ? (a[Number(n[4])] || Number(b[n[4][0]]) + Number(a[n[4][1]])) + ' hundred ' : '';
  str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || parseInt(b[n[5][0]]+ Number(a[n[5][1]]))) + ' ' : '';
  return str
}

export function applyComma(val) {
  if (val) {
    if (typeof val !== "string") {
      val = val.toString();
    }

    // Remove existing commas from the string
    val = val.replace(/,/g, "");

    // Insert commas without using regex
    let amount = "";
    let counter = 0;

    for (let i = val.length - 1; i >= 0; i--) {
      amount = val[i] + amount;
      counter++;

      // Insert a comma after every three digits
      if (counter === 3 && i !== 0) {
        amount = "," + amount;
        counter = 0;
      }
    }

    return amount;
  } else {
    return "";
  }
}


export function lineCapital(line){
  if(!line?.length){
    return ''
  }
  line = line.toLowerCase()
  let updatedLine = line[0].toUpperCase() + line.substr(1)
  return updatedLine
}

export function wordCapital(line){
  if(!line?.length){
    return ''
  }

  let separatedWords = line.split(' ')
  separatedWords = separatedWords.map(element => {
    element.toLowerCase()
    return lineCapital(element)
  });
  
  let updatedLine = separatedWords.join(' ')
  return updatedLine

}


export function deepCopy(obj){
  return JSON.parse(JSON.stringify(obj))
}

export function addDaysToCurrentDate(days) {
  let currentDate = new Date();

  currentDate.setDate(currentDate.getDate() + days);

  let formattedDate = currentDate.toISOString().split('T')[0];

  return formattedDate;
}

export function formatDatetoDDMMYYY(date){
  const parts = date.split("-");
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
}

export function formatTime(inputTime) {
  const [hour, minute, period] = inputTime.split(/:|\s/);

  const formattedHour = hour.padStart(2, '0');
  const formattedMinute = minute.padStart(2, '0');

  const formattedTime = `${formattedHour}:${formattedMinute} ${period.toUpperCase()}`;

  return formattedTime;
}

export const maskInFormat = (dateOfTargetInEpoch) => {
  if (!dateOfTargetInEpoch){
    return ""
  }
  const date = new Date(dateOfTargetInEpoch);
  const fullYear = date.getFullYear();
  return `**/**/**${fullYear.toString().slice(2,4)}`
}

export function maskAlternateCharsInEmail(email) {
  if (!email){
    return "";
  }
  if (!email.includes("@")){
    let maskedUsername = maskAlternateChars(email);
    return `${maskedUsername}`;
  }else{
    const [username, domain] = email.split('@');
    let maskedUsername = maskAlternateChars(username);
    return `${maskedUsername}@${domain}`;
  }
}

function maskAlternateChars(str) {
  if (str.length === 1) {
    return '*'; 
  }

  let maskedStr = '';
  for (let i = 0; i < str.length; i++) {
    if (i % 2 === 0) {
      maskedStr += str[i];
    } else {
      maskedStr += '*';
    }
  }
  return maskedStr;
}

export function calculateAge(dobEpoch) {
  let age = Math.floor(moment(new Date()).diff(moment.unix(dobEpoch).utcOffset("+05:30"), 'years', true))
  return age;
}

const getRandomVal = () => Math.random() // NOSONAR

const generateRandomChar = (min, max) =>
  String.fromCharCode(Math.floor
    (getRandomVal() * (max - min + 1) + min));

export const generateCaptchaText = () => {
  let captcha = '';
  for (let i = 0; i < 3; i++) {
    captcha += generateRandomChar(65, 90);  // Upper case alphabets
    captcha += generateRandomChar(48, 57);  // digits
  }
  const captchatext = captcha.split('').sort(() => getRandomVal() - 0.5).join('');
  return captchatext;
};

export const drawCaptchaOnCanvas = (ctx, captcha) => {
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  const textColors = ['rgb(0,0,0)', 'rgb(130,130,130)'];
  const letterSpace = 150 / captcha.length;
  for (let i = 0; i < captcha.length; i++) {
    const xInitialSpace = 25;
    ctx.font = '25px Arial';
    ctx.fillStyle = textColors[Math.floor(getRandomVal() * 2)];
    ctx.fillText(captcha[i], xInitialSpace + i * letterSpace, Math.floor(getRandomVal() * 16 + 20), 100);
  }
};

export function normalizeSpaces(str) {
  if (!str) return "";
  return str.trim().replace(/\s+/g, ' ');
}

export function setCookiesFromBackend(cookies = []) {
  if (!Array.isArray(cookies)) return;

  cookies.forEach((cookie) => {
    const {
      name,
      value,
      options = {},
    } = cookie;

    if (!name) return;

    // Defensive defaults
    const safeOptions = {
      path: "/",
      ...options,
    };
    Cookies.set(name, value, safeOptions);
  });
}

export function clearAllCookies() {
  if (window.document){
    const cookies = document.cookie.split(";");
  
    for (let cookie of cookies) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie =
        name +
        "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    }
  }
}